<div class="page-content">
    <div class="row">
        <div class="col-lg-12">
            <div class="ibox ">
                <div class="ibox-body">
                    <div class="iboxcontent">
                        <h3>Post Job</h3>
                        <div class="stepsnumber">
                            <span>Steps 5/5</span>
                        </div>
                    </div>
                    <form [formGroup]="form" (ngSubmit)="onSubmit()">
                        <h6 class="heading-6 mb-2">Preferences</h6>
                        <p class="para-6">{{filledData?.JobPost?.jobTitle || "-"}}</p>
                        <p class="para11 pt-3 pb-3">This job is eligible for the following <span
                                class="orangeText">*</span></p>
                        <ul class="suggestedskills">
                            <li *ngFor="let elg of allEligibles; let i=index;" (click)="selectedEligibles(i,$event)"
                                [ngClass]="elg.selected == true ? 'selected' : ''" class="cap">{{elg.name}}</li>
                        </ul>
                        <div class="text-danger" *ngIf="showError">Please select job eligible option.</div>
                        <p class="para11 pt-3 pb-3">Select the personalities that best suits this job</p>
                        <ul class="suggestedskills">
                            <li *ngFor="let per of allPersonalities; let i=index;"
                                (click)="selectedPersonalities(i,$event)"
                                [ngClass]="per.selected == true ? 'selected' : ''" class="cap">{{per.title}}</li>
                            <button class="showmore" *ngIf="allPersonalities > 8">Show 8 more <img
                                    src="assets/images/showmore.svg"></button>
                        </ul>
                        <div class="pt-4 pb-4">
                            <p class="para11 pt-3 pb-3">Does the covid vaccination certificate required?</p>
                            <div class="customradiobox">
                                <div class="custom_radio m-0">
                                    <input type="radio" id="featured-1" name="vaccinationCerificate"
                                        formControlName="vaccinationCerificate" value="1"><label
                                        for="featured-1">Yes</label>
                                    <input type="radio" id="featured-2" name="vaccinationCerificate"
                                        formControlName="vaccinationCerificate" value="0"><label
                                        for="featured-2">No</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-lg-12 col-md-12">
                                <div class="form-group">
                                    <h6 class="heading-6">Travel requirements</h6>
                                    <ul class="suggestedskills">
                                        <li *ngFor="let trav of allTravelRequirements; let i=index;"
                                            (click)="selectedTravelRequirements(i,$event)"
                                            [ngClass]="trav.selected == true ? 'selected' : ''">{{trav.name}}</li>
                                    </ul>
                                </div>
                                <div class="col-md-6 col-lg-6 p-0 ">
                                    <div class="form-group">
                                        <label class="para11 questiontext">How many people do you need to hire for this
                                            job opening?</label>
                                        <input type="text" name="" class="form-control" placeholder="Enter"
                                            formControlName="noOfPeopleRequired" (keypress)="preventNumbers($event)" maxlength="10">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <h6 class="para11 heading-6 questiontext">How quickly do you need to hire?</h6>
                                    <ul class="suggestedskills">
                                        <li *ngFor="let hire of allHire; let i=index;" (click)="selectedHire(i,$event)"
                                            [ngClass]="hire.selected == true ? 'selected' : ''">{{hire.name}}</li>
                                    </ul>
                                </div>
                                <div class="col-md-12 col-lg-12 col-sm-12 p-0 " formArrayName="emailsIds">
                                    <div class="form-group" *ngFor="let add of getEmail(); let i=index">
                                        <label class="para11 questiontext">Updates will be sent to</label>
                                        <div [formGroupName]="i">
                                            <input type="text" name="" class="form-control" placeholder="Enter"
                                                formControlName="emailId"
                                                pattern='^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$'>
                                        </div>
                                        <div class="text-danger" *ngIf="showError && checkPattern(i)">
                                            *Please enter valid email.
                                        </div>
                                        <a href="javascript:void(0)" class="borderBtn addEmail planbtn mt-4 wdth"
                                            (click)="addMoreEmail(i)"><img src="assets/images/ic_add_skill.svg"> Add
                                            email</a>
                                    </div>
                                </div>
                                <div class="col-md-12 col-lg-12 col-sm-12 p-0">
                                    <div class="form-group">
                                        <label class="para11">Let potential candidates call you directly about this
                                            job</label>
                                        <div class="countryCode job">
                                            <span><img src="../../../../../assets/images/ic_flag.png"><input type="text"
                                                    class="form-control" formControlName="countryCode" readonly
                                                    placeholder="(+1)"></span>
                                            <input type="text" name="" class="form-control pl" placeholder="Enter"
                                                formControlName="phoneNumber" maxlength="10"
                                                (keypress)="preventNumbers($event)">
                                        </div>
                                        <p class="para6 fullWidth">By entering your phone number, you are agree to
                                            receive calls and text messages from Honorvet and potential candidates
                                            related to this job posting.</p>
                                    </div>
                                    <div class="d-flex btnWrap">
                                        <a href="javascript:void(0);" class="planbtn greyBtn" (click)="back()">Back</a>
                                        <input type="submit" value="Continue" class="planbtn fill" />
                                        <input type="submit" value="Show preview"
                                            class="borderBtn planbtn wdth previewBtn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>